import {
	Button,
	Image,
	PasswordInput,
	Stack,
	Text,
	TextInput,
	useMantineTheme,
} from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { Link, useNavigate } from "@tanstack/react-router";
import { fetchAuthSession, signIn } from "aws-amplify/auth";
import { defaultStorage } from "aws-amplify/utils";
import { loginFormSchema } from "../../schemas/loginForm";
import type { LoginForm as LoginFormType } from "../../types/loginForm";
import { FormLayout } from "../common/FormLayout";

export const LoginForm = () => {
	const navigate = useNavigate();

	const theme = useMantineTheme();

	const form = useForm<LoginFormType>({
		mode: "uncontrolled",
		initialValues: {
			email: "",
			password: "",
		},
		validate: zodResolver(loginFormSchema),
	});

	const handleSubmit = async (values: LoginFormType) => {
		try {
			const { nextStep } = await signIn({
				username: values.email,
				password: values.password,
			});

			if (
				nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
			) {
				navigate({ to: "/reset/password" });
				return;
			}

			const session = await fetchAuthSession();

			if (session.tokens?.accessToken?.toString()) {
				defaultStorage.setItem(
					"jwt_token",
					session.tokens.idToken?.toString() ?? "",
				);
			}

			navigate({ to: "/" });
		} catch {
			// TODO: エラーハンドリング
			notifications.show({
				title: "ログインに失敗しました",
				message:
					"ログインに失敗しました。メールアドレスもしくはパスワードを確認して再度お試しください。",
				color: "red",
			});
		}
	};

	return (
		<FormLayout>
			<Stack w={162} h={30} align="center" justify="center" mx="auto">
				<Image src="/Logo.png" alt="logo" />
			</Stack>
			<form onSubmit={form.onSubmit(handleSubmit)}>
				<Stack gap="md">
					<TextInput
						size="md"
						w={320}
						key={form.key("email")}
						{...form.getInputProps("email")}
						placeholder="メールアドレス"
					/>
					<PasswordInput
						size="md"
						w={320}
						key={form.key("password")}
						{...form.getInputProps("password")}
						placeholder="パスワード"
					/>
					<Text
						component={Link}
						to="https://ai-recruiter.jp/contact_inapp"
						style={{ color: theme.colors.primary[6] }}
					>
						パスワードがわからない方
					</Text>
					<Button type="submit" fullWidth size="md">
						<Text>ログイン</Text>
					</Button>
				</Stack>
			</form>
		</FormLayout>
	);
};
